import { useFeatureFlagsState } from "hooks/FeatureFlagsContext";
import { SearchResultsState } from "interfaces/context/searchResultsContextInterfaces";
import { AlertCTA } from "./AlertCTA";
import { Heading } from "./Heading";
import styles from "./SearchHeader.module.scss";

export type SearchHeaderProps = {
    category: string | null;
    company: string | null;
    keyword: string | null;
    level: string | null;
    location: string | null;
    state: SearchResultsState;
};

export const SearchHeader = (props: SearchHeaderProps) => {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    const { state, ...alertProps } = props;
    const { FEATURE_FLAG_JOB_ALERTS } = useFeatureFlagsState();
    return (
        <div className={styles.wrapper}>
            <Heading {...props} />
            {!!FEATURE_FLAG_JOB_ALERTS && <AlertCTA {...alertProps} />}
        </div>
    );
};

SearchHeader.displayName = "SearchHeader";
